import { render, staticRenderFns } from "./GameSelection.vue?vue&type=template&id=3cb0c24c&lang=pug&"
import script from "./GameSelection.vue?vue&type=script&lang=js&"
export * from "./GameSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports